import { Switch } from '@chakra-ui/react';

const BooleanToggle = ({
    field,
    form: { setFieldValue },
    isChecked,
    onChange,
    walkthroughId,
    isDisabled = false,
    ...props
}) => {
    const handleChange = (e) => {
        const value = e.target.checked;

        // Update Formik field value
        if (field && setFieldValue) {
            setFieldValue(field.name, value);
        }

        // Call custom onChange if provided
        if (onChange) {
            onChange(value);
        }
    };

    return (
        <Switch
            {...field}
            {...props}
            isChecked={isDisabled ? false : isChecked}
            onChange={handleChange}
            data-walkthroughid={walkthroughId}
            isDisabled={isDisabled}
        />
    );
};

export default BooleanToggle;
